import apiClient from '../clienteFebosAPI';

const RESOURCE = '/aprobaciones';

export const fileFlowDetails = (payload) => {
  const params = apiClient.queryParams(payload);

  return apiClient.get(`${RESOURCE}/${payload.aprobacionId}/ejecucion/${payload.ejecucionId}/estado?${params}`, {
    operacionId: 'fileFlowDetails'
  });
};

export const cancelFile = (payload) => {
  const params = apiClient.queryParams(payload);

  return apiClient.put(`${RESOURCE}/${payload.aprobacionId}/ejecucion/${payload.ejecucionId}/anular?${params}`,
    {}, { operacionId: 'io.file.cancel' });
};

export const retainFile = (
  {
    aprobacionId,
    ejecucionId,
    pasoId,
    comment
  }
) => {
  const params = apiClient.queryParams({
    idAprobacion: aprobacionId,
    idEjecucion: ejecucionId,
    pasoId
  });

  return apiClient.post(`${RESOURCE}/ejecuciones/${ejecucionId}/pasos/${pasoId}/retener?${params}`,
    { justificacion: comment }, { operacionId: 'io.file.retain' });
};

export const disparageFile = (payload) => {
  const params = apiClient.queryParams(payload);

  return apiClient.delete(`${RESOURCE}/${payload.aprobacionId}/ejecucion/${payload.ejecucionId}?${params}`,
    {}, { operacionId: 'io.disparage.cancel' });
};

export const getAttachments = (payload) => {
  const params = apiClient.queryParams(payload);

  return apiClient.get(`${RESOURCE}/${payload.aprobacionId}/ejecucion/${payload.ejecucionId}/previsualizacion?${params}`,
    { operacionId: 'io.download.attachments' });
};

export const setSubstituteFlows = (
  {
    selectedFlows,
    permanent,
    userTarget,
    userSubstitute,
    substituteName,
    from,
    to
  }
) => apiClient.post(`${RESOURCE}/suplencia`,
  {
    idsFlujos: selectedFlows,
    permanente: permanent,
    usuarioIdAnterior: userTarget,
    usuarioIdNuevo: userSubstitute,
    usuarioNombreNuevo: substituteName,
    fechaDesde: from,
    fechaHasta: to
  }, { operacionId: 'io.substitute.flows' });

export const sendToFlowFile = (payload) => {
  const params = apiClient.queryParams(payload.params);

  return apiClient.post(`${RESOURCE}/${payload.params.aprobacionId}/ejecucion?${params}`,
    payload.body, { operacionId: 'io.send.flow' });
};

export const clTraysList = (payload) => {
  const params = apiClient.queryParams(payload);

  return apiClient.get(`${RESOURCE}/bandeja?${params}`, {
    operacionId: 'io.trays'
  });
};

export const commentFlow = (paramsJson, comment) => {
  const params = apiClient.queryParams(paramsJson);
  return apiClient
    .post(`${RESOURCE}/${paramsJson.idAprobacion}/ejecucion/${paramsJson.idEjecucion}/paso/${paramsJson.pasoId}/comentario?${params}`,
      comment, { operacionId: 'comment.flow' });
};

export const deleteCommentFlow = (paramsJson) => {
  const params = apiClient.queryParams(paramsJson);
  return apiClient
    .delete(`${RESOURCE}/${paramsJson.idAprobacion}/ejecucion/${paramsJson.idEjecucion}/comentario/${paramsJson.comentarioId}?${params}`, { operacionId: 'delete.comment.flow' });
};

export const deleteCommentAttachmentFlow = (paramsJson) => {
  const params = apiClient.queryParams(paramsJson);
  return apiClient
    .delete(`${RESOURCE}/${paramsJson.idAprobacion}/ejecucion/${paramsJson.idEjecucion}/comentario/${paramsJson.comentarioId}/adjuntos/${paramsJson.adjuntoId}?${params}`, { operacionId: 'delete.comment-attachment.flow' });
};

export const processFlow = (paramsJson, comment) => {
  const params = apiClient.queryParams(paramsJson);
  return apiClient
    .put(`${RESOURCE}/${paramsJson.idAprobacion}/ejecucion/${paramsJson.idEjecucion}/paso/${paramsJson.pasoId}/proceso?${params}`,
      comment, { operacionId: 'process.flow' });
};

export const makePrivateFlow = (flowId, flow) => apiClient
  .put(`${RESOURCE}/ejecuciones/${flowId}/cambiar/privacidad`,
    flow, { operacionId: 'make.private.flow' });

export const signFlow = (sign) => {
  const params = apiClient.queryParams(sign);
  return apiClient
    .put(`${RESOURCE}/${sign.aprobacionId}/ejecucion/${sign.ejecucionId}/firmar?${params}`,
      sign, { operacionId: 'sign.flow' });
};

export const signFlowMassive = (payload) => {
  const params = apiClient.queryParams(payload.requestParams);
  return apiClient
    .post(`${RESOURCE}/0/ejecucion/0/firmar?${params}`,
      payload.body, { operacionId: 'sign.flow' });
};

export const manageFlow = (sign, meta) => {
  const params = apiClient.queryParams(sign);

  return apiClient
    .put(`${RESOURCE}/${sign.aprobacionId}/ejecucion/${sign.ejecucionId}/firmar?${params}`,
      { meta }, { operacionId: 'manage-office.flow' });
};

export const clApprovalsDashboard = (payload) => {
  const params = apiClient.queryParams(payload);

  return apiClient.get(`${RESOURCE}/reporte?${params}`, {
    operacionId: 'io.dashboard.approvals'
  });
};

export const addStepFlow = (aprobacionId, step) => apiClient
  .post(`${RESOURCE}/ejecuciones/${aprobacionId}/pasos?`,
    step, { operacionId: 'add-step.flow' });

export const getExecutionSteps = (ejecucionId) => apiClient
  .get(`${RESOURCE}/ejecuciones/${ejecucionId}/pasos`,
    { operacionId: 'io.execution.steps' });

export const changeStepEmail = (ejecucionId, pasoId, body) => {
  const params = apiClient.queryParams({ aplicacion: 'ED' });
  return apiClient.put(
    `${RESOURCE}/ejecuciones/${ejecucionId}/pasos/${pasoId}/cambiar-correo?${params}`,
    body,
    { operacionId: 'io.step.change-email' }
  );
};

export const listApprovals = (payload) => {
  const params = apiClient.queryParams(payload.params);
  return apiClient.get(
    `${RESOURCE}?${params}`, { operacionId: 'io.aprovals.list' }
  );
};

export const createApprovalsTemplate = (payload) => apiClient.post(
  `${RESOURCE}`,
  {
    aprobacion: payload.aprobacion,
    observadores: payload.observadores,
    gatilladores: payload.gatilladores,
    pasos: payload.pasos
  },
  { operacionId: 'io.aprobaciones.plantilla.crear' }
);

export const getApprovalTemplate = (payload) => {
  const params = apiClient.queryParams(payload);
  return apiClient.get(
    `${RESOURCE}?${params}`,
    { operacionId: 'io.aprobaciones.plantilla.obtener' }
  );
};

export const deleteApprovalTemplate = (payload) => {
  const params = apiClient.queryParams(payload);
  return apiClient.delete(
    `${RESOURCE}/${payload.aprobacionId}?${params}`,
    { operacionId: 'io.aprobaciones.plantilla.eliminar' }
  );
};

export const extraActionsApproval = (id, param = {}, body = {}) => {
  const params = apiClient.queryParams(param);
  return apiClient.post(
    `v2/aprobaciones/ejecuciones/${id}/extras?${params}`,
    body,
    { operacionId: 'io.aprobaciones.accion.extra' }
  );
};

/**
 * Obtiene una ejecución externa (flujo de completitud de datos) a partir del
 * JWT que llega en el enlace del correo. Endpoint público: la autenticación es
 * el propio token, enviado en la cabecera `Authorization`.
 */
export const getExternalExecution = (token) => apiClient.get(
  'v2/aprobaciones/externas/',
  {
    operacionId: 'io.aprobaciones.externas.obtener',
    headers: { Authorization: token }
  }
);

/**
 * Procesa el envío de un paso de "Completitud de datos": manda los valores que
 * completó el responsable externo. El backend los fusiona/valida contra el
 * `configuration`, estampa el PDF y avanza el paso. Endpoint público: la
 * autenticación es el JWT en la cabecera `Authorization`.
 *
 * @param {string} token  JWT del enlace.
 * @param {Array<{id:string, valor:string}>} valores  valores por id de campo.
 */
export const postExternalCompletion = (token, valores) => apiClient.post(
  'v2/aprobaciones/externas/completitud',
  { valores: JSON.stringify(valores) },
  {
    operacionId: 'io.aprobaciones.externas.completitud',
    headers: { Authorization: token }
  }
);

export const getSubstitutionChain = (ejecucionId, param = {}) => {
  const params = apiClient.queryParams(param);
  return apiClient.get(
    `v2/aprobaciones/ejecuciones/${ejecucionId}/cadena-suplencia/?${params}`,
    { operacionId: 'io.aprobaciones.ejecuciones.cadena.suplencia.get' }
  );
};
